// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite20: FC<Favorite20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.214 7.224v-.001l-.003-.016a5.583 5.583 0 0 0-.094-.36 6.256 6.256 0 0 0-.354-.928c-.327-.68-.79-1.286-1.41-1.554l-.125-.05a2.96 2.96 0 0 0-2.017.024 2.84 2.84 0 0 0-1.259.897c-.352.451-.65 1.142-.652 2.226v.002a2.24 2.24 0 0 0 .034.247 4.1 4.1 0 0 0 .276.859c.322.736.988 1.789 2.38 2.906a25.76 25.76 0 0 1 3.483 3.378c.198.234.372.449.521.639.136-.174.294-.368.473-.58a26.512 26.512 0 0 1 3.539-3.434c1.387-1.125 2.056-2.18 2.38-2.916.163-.37.241-.666.279-.858a2.243 2.243 0 0 0 .035-.243c-.002-1.085-.3-1.775-.652-2.226a2.847 2.847 0 0 0-1.259-.898v.001a2.959 2.959 0 0 0-2.016-.023c-.683.237-1.187.878-1.536 1.603a6.266 6.266 0 0 0-.448 1.288l-.003.016-.039.137a.8.8 0 0 1-1.533-.136Zm8.286.252.8.009v.022l-.002.036a3.764 3.764 0 0 1-.063.472 5.74 5.74 0 0 1-.384 1.192c-.43.975-1.257 2.232-2.837 3.514a24.905 24.905 0 0 0-3.325 3.226c-.354.417-.61.756-.777.987a9.224 9.224 0 0 0-.224.324l-.008.013-.665 1.071-.686-1.057-.002-.003-.01-.015-.047-.07c-.044-.062-.11-.157-.2-.279-.18-.244-.453-.6-.817-1.028a24.153 24.153 0 0 0-3.264-3.166C3.4 11.449 2.571 10.189 2.144 9.21a5.68 5.68 0 0 1-.381-1.198 3.772 3.772 0 0 1-.06-.475L1.7 7.502V7.48l.8-.004-.8.003v-.003c0-1.407.393-2.46.991-3.226a4.435 4.435 0 0 1 1.957-1.409l.189-.066c.948-.31 1.97-.3 2.916.029C8.852 3.186 9.559 4.056 10 4.837c.441-.781 1.149-1.65 2.247-2.032a4.56 4.56 0 0 1 3.105.036 4.444 4.444 0 0 1 1.957 1.41c.598.766.99 1.818.99 3.225v.008l-.799-.008Z" />
        </svg>
    );
};

export default Favorite20;
